if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBlogOverview)
} else {
    initBlogOverview()
}

async function initBlogOverview() {
    setTimeout(async () => {
        const [{createApp}] = await Promise.all([import("vue")])

        const BlogApp = createApp({})
        BlogApp.component("blog-permission-popup", () => import("@/components/Frontend/BlogPermissionPopup.vue"))
        BlogApp.component("blog-post-list", () => import("@/components/Frontend/BlogPostList.vue"))
        BlogApp.mount("#app")

        initializeTabsAndAccordion()
    }, 600)
}

function initializeTabsAndAccordion() {
    const tabContainers = document.querySelectorAll(".blog-posts-container")

    tabContainers.forEach((container) => {
        const tabs = container.querySelectorAll(".tab-menu-item")
        const tabContents = container.querySelectorAll(".blog-tab")

        tabs.forEach((tab, index) => {
            tab.addEventListener("click", (e) => {
                e.preventDefault()

                tabs.forEach((el) => el.classList.remove("active"))
                tabContents.forEach((el) => el.classList.remove("active"))

                tab.classList.add("active")
                tabContents[index].classList.add("active")
            })
        })
    })

    const buttons = document.querySelectorAll(".blog-tabs-menu-title")

    buttons.forEach((button) => {
        button.addEventListener("click", toggleAccordion)
    })

    function toggleAccordion(e) {
        e.preventDefault()
        const isExpanded = this.getAttribute("aria-expanded") === "true"

        buttons.forEach((btn) => btn.setAttribute("aria-expanded", "false"))

        if (!isExpanded) {
            this.setAttribute("aria-expanded", "true")
        }
    }
}
